'use strict';

//=include  ../../MetricsTracker/booker/metrics.js
import BookerTracker from '../../MetricsTracker/booker/metrics';
import GlobalUtil from '../../utils/pricetravel/shared/globalUtil';
//import { StorageService } from '../../vue/services/StorageService';
//import { CookieService } from '../../vue/services/CookieService';
import { SearchHistory } from '../../utils/pricetravel/shared/searchHistory';

window.app.controller('BookerPackageController', controller);

controller.$inject = ["$scope", "$http", "$location", "$rootScope"];

function controller($scope, $http, $timeout, $rootScope) {
    let vm = this;
    let config = window.__pt.settings.site;
    let setting = window.__pt.settings;
    let lang = window.__pt.ln;
    let fn = window.__pt.fn;
    let defaultDate = fn.getDate()
    let _placeOrigin = window.__pt.placeOrigin || {};
    let _placeDestination = window.__pt.placeDestination || {};
    let _list = "";
    let _inputName = "";
    let _datePicker = {}
    let _picker = null;
    let _placesTypes = {};
    let tracker = new BookerTracker();
    let valuesDefaults = {
        tripMode: "undefined",
        tripCabin: "undefined",
        QuoteList: true,
        QuoteFlight: true,
        keyWordId: "0",
        keyWordTable: "0",
        actionType: 2,
        nonStopOnly: "undefined",
        page: 1
    }
    let localeDatePicker = {
        format: setting.formatBoxDate,
        firstDay: 0,
        applyLabel: lang.ok,
        cancelLabel: lang.cancel
    }
    let lastQuery = '';
    vm.siteUrl = window.__pt.settings.site.siteUrl;
    vm.typePackageSuggestion = 19;
    vm.submit = false;
    vm.destinationEquals = false;
    vm.years = [];
    vm.suggestion = {
        from: {
            results: [],
            show: false
        },
        to: {
            results: [],
            show: false
        },
        paxes: false
    };
    vm.hasResult = false;
    vm.validation = {
        paxes: true,
        checkIn: true,
        checkOut: true,
        dates: true
    }
    vm.settingPaxes = {
        minAdults: 1,
        maxAdults: 9,
        minChildren: 0,
        maxChildren: 6,
        minAge: 1,
        maxAge: 17,
        rooms: 4,
        totalPaxes: 9
    };

    vm.algoliaUrl = "https://img.cdnpth.com/media/assets/recent-search-imgs/iatas/";
    vm.data = setting.defaultPackage;
    vm.placeInputHasFocus = {
        to: false,
        from: false
    };

    vm.history = {
        from: [],
        to: []
    };
    vm.showDefaultSuggestions = {
        from: false,
        to: false
    };
    vm.error_paxes = false;
    let origin = null;
    let _globalUtil = new GlobalUtil();
    let _userKey = _globalUtil.getUserKey();

    $rootScope.$on(setting.bookerValuesEventPackage, function (event, args) {
        vm.data = args.data;
        vm.data.checkIn = fn.getDate(vm.data.checkIn);
        vm.data.checkOut = fn.getDate(vm.data.checkOut);
        $timeout(() => vm.onSubmit(vm.form, true), 100)
    });

    vm.onSearch = (value, list, input, focus) => {
        if (value === "" || value === null || value === undefined || value.length < 3) {
            vm.showDefaultSuggestions[list] = true;
            AlgoliaSearch(list);
        }

        if (!value || (value && value.length < 3)) {
            return;
        }
        vm.hasResult = false;
        if (vm.form[input].$valid) {
            vm.showDefaultSuggestions[list] = false;
            _inputName = focus;
            _list = list;
            let destination = list === 'from' ? 0 : 1
            const params = {
                query: value,
                language: config.culture,
                placeTypes: config.placesTypePackages,
                from: 0,
                size: 10,
                usersearch: _userKey,
                site: config.code,
                destination: destination,
                analyticsTags: getAnalyticsTags(),
                version: list === 'from' ? "v2" : "v1",
            }

            $http.get(config.endPoints.suggestionPackageUrl, { params })
                .then(function tap(resp) {

                    if (resp.data.length > 0) {
                        lastQuery = params.query;
                        tracker.metricAutocompletePackageShown(params.query, resp.data, list);
                    }
                    else {
                        tracker.metricAutocompletePackageNoResults(params.query);
                    }
                    return resp;
                })
                .then(onSuccessSuggestion, onError)
        }
    }


    vm.onSubmit = (form) => {

        if (this.validAgeChildrenforAdult()) {
            this.showPaxes();
            return;
        }

        vm.submit = true;
        vm.validation.paxes = isValidPax(vm.data.paxes, form);
        vm.validation.checkIn = isValidDate(defaultDate, vm.data.checkIn);
        vm.validation.checkOut = isValidDate(defaultDate, vm.data.checkOut);
        vm.validation.dates = isValidDate(vm.data.checkIn, vm.data.checkOut);

        if (form.$valid && vm.validation.paxes && vm.validation.checkIn && vm.validation.checkOut && vm.validation.dates) {
            if (vm.data.place_selected.placeCode == vm.data.place_selected_to.placeCode) {
                vm.destinationEquals = true;
            } else {
                vm.destinationEquals = false;
                let paramsQuery = fn.search();
                let paxesData = SearchHistory.mapPackagePaxQuery(vm.data.paxes);
                let data = {
                    startingFromDateTime: fn.formatDate(vm.data.checkIn, setting.formatDate),
                    returningFromDateTime: fn.formatDate(vm.data.checkOut, setting.formatDate),
                    checkIn: fn.formatDate(vm.data.checkIn, setting.formatDate),
                    checkOut: fn.formatDate(vm.data.checkOut, setting.formatDate),
                    startingFromAirport: vm.data.place_selected.placeCode,
                    returningFromAirport: vm.data.place_selected_to.placeCode,
                    startingPlaceId: vm.data.place_selected.placeId,
                    returningPlaceId: vm.data.place_selected_to.placeId
                };

                if (paramsQuery.CampaignToken) {
                    data.CampaignToken = paramsQuery.CampaignToken;
                }


                data = { ...data, ...paxesData };

                var path = `${config.pathPackages}`;

                tracker.metricBookerPackage('booker', { vmData: vm.data, data });

                var form = document.createElement("form");
                form.setAttribute("method", "get");
                form.setAttribute("action", `${path}`);

                for (var key in data) {
                    if (data[key]) {
                        var hiddenField = document.createElement("input");
                        hiddenField.setAttribute("type", "hidden");
                        hiddenField.setAttribute("name", key);
                        hiddenField.setAttribute("value", data[key]);

                        form.appendChild(hiddenField);
                    }
                }

                SearchHistory.set(vm.data, "P");

                $("#loader-page").removeClass("d-none");
                document.body.appendChild(form);
                form.submit();
            }
        }
    }

    vm.onSelect = (item, type, suffix, prefix) => {
        vm.data[`place_name${suffix}`] = item.version == "v2" ? textOrigen(item) : textValidation(item);
        vm.data[`place_selected${suffix}`] = item;
        vm.suggestion[type].show = false;
        vm.placeInputHasFocus[type] = false;
        var item_category = '';
        if (type === 'from') {
            origin = item.placeCode;
        }
        tracker.metricAutocompletePackageSelect(item, lastQuery, type, prefix);
        
    }

    vm.showPaxes = () => {
        vm.suggestion.paxes = true;
    }

    vm.addRoom = () => {
        if (ValidTotalPaxes(vm.settingPaxes.totalPaxes)) {
            return;
        }

        if (vm.settingPaxes.rooms > vm.data.paxes.length) {
            const paxesDefault = fn.clone(setting.defaultPaxes);
            vm.data.paxes.push(paxesDefault);
            updateInputPaxes();
        }
    }

    vm.onFocus = (element, input) => {
        _list = element;
        _inputName = input;
        vm.hasResult = true;
        setTimeout(() => {
            AlgoliaSearch(element);
        }, 200)

        if (vm.suggestion[element]["results"].length) {
            setTimeout(() => {
                $scope.$apply(() => {
                    vm.suggestion[element]["show"] = true;
                    if (fn.mobileAndTabletCheck()) {
                        onFocusElement(`${input}_modal`)
                    }
                });
            }, 250)
        }
    }

    vm.getIcon = (type) => {
        let icon = "icons-globe-outline"//
        switch (type) {
            case 6:
                icon = "icons-globe-outline";//
                break;
            case 3:
                icon = "icons-location"; //
                break;
            case 11:
                icon = "icons-plane-airport";
                break;
            case 7:
                icon = "icons-compass";//
                break;
            case 14:
                icon = "icons-hotel";//
                break;
            case 12:
                icon = "icons-monument";//
                break;
            case 19:
                icon = "icons-subdirectory-arrow-right";
                break;
        }

        return [icon]
    }
    vm.removePax = (pax, prop, minValue) => {
        if ((pax[prop] - 1) >= minValue) {
            pax[prop] -= 1;
        }
        updateInputPaxes();
        this.validAgeChildrenforAdult();

        if (ValidTotalPaxes(vm.settingPaxes.totalPaxes)) {
            return;
        }
    }

    vm.addPax = (pax, prop, maxValue) => {
        if (ValidTotalPaxes(maxValue)) {
            return;
        }

        if ((pax[prop] + 1) <= maxValue) {
            pax[prop] += 1;
        }
        updateInputPaxes();
        this.validAgeChildrenforAdult();
    }


    vm.removeChildren = (pax, prop, minValue) => {
        if ((pax[prop].length - 1) >= minValue) {
            pax[prop].splice(pax[prop].length - 1, 1);
        }
        updateInputPaxes();

        if (ValidTotalPaxes(vm.settingPaxes.totalPaxes)) {
            return;
        }
    }

    vm.addChildren = (pax, prop, maxValue) => {
        if (ValidTotalPaxes(maxValue)) {
            return;
        }

        if ((pax[prop].length + 1) <= maxValue) {
            pax[prop].push({
                year: null
            });
        }
        updateInputPaxes();

    }

    vm.validAgeChildrenforAdult = () => {
        let paxesKeys = {};
        let adults = 0;
        let kids = 0;
        let agekids = [];
        let rooms = vm.data.paxes.length;

        for (let i = 0; i < rooms; i++) {
            const room = vm.data.paxes[i];

            adults += room.adults;

            let childrens = room.children.length;
            let childreJoin = [];
            for (let c = 0; c < childrens; c++) {
                const childrenRoom = room.children[c];
                childreJoin.push(childrenRoom.year);
                agekids.push(childrenRoom.year);
                kids += 1;
            }

        }
        paxesKeys[`adults`] = adults;
        paxesKeys[`kids`] = kids;
        paxesKeys[`agekids`] = agekids.join(",");

        let totalChildren = 0;
        if (paxesKeys[`adults`] < paxesKeys[`kids`]) {

            agekids.forEach((age, index) => {
                if (age == 1)
                    totalChildren++;
            });

            if (totalChildren > paxesKeys[`adults`]) {
                return true;
            }
            else return false;
        }
        else return false;

    }

    vm.onClose = (obj, prop, type, suffix) => {
        vm.handleCloseSuggestions(suffix);
        if (somePaxHasError()) {
            vm.form.$setSubmitted();
            return;
        }
        obj[prop] = false;
        setValidation(prop);
        vm.placeInputHasFocus[type] = false;
    }

    vm.onRemove = (obj, prop, index) => {
        obj[prop].splice(index, 1);
        updateInputPaxes();

        if (ValidTotalPaxes(vm.settingPaxes.totalPaxes)) {
            return;
        }
    }


    vm.hasError = (form, property) => {
        let input = form[property];
        return form.$submitted && input.$invalid
    }


    vm.isInvalidInput = (form, inputName, position, inputNumber) => {
        return form.$submitted && form[`${inputName}_${position}_${inputNumber}`].$invalid
    }

    vm.onClickOutside = (element, prop, type, suffix) => {
        element[prop] = false;
        setValidation(prop);
        vm.handleCloseSuggestions(suffix);
        vm.placeInputHasFocus[type] = false;
    }


    vm.onChangeFlight = () => {
        initDatePicker();
    }

    vm.deleteSelection = (input, selection, type, inputFocus) => {
        vm.data[input] = null;
        vm.data[`${selection}${type.length ? '_' + type : ''}`] = {};
        onFocusElement(inputFocus);
    }

    vm.clickInputInMobile = (focus, type, suffix = "") => {
        _inputName = focus;
        vm.handleCloseSuggestions(suffix);
        if (!Object.keys(vm.data[`place_selected${suffix}`]).length && vm.data[`place_name${suffix}`] == null) {
            vm.showDefaultSuggestions[type] = true;
            vm.onFocus(type, focus);
        }
        vm.placeInputHasFocus[type] = true;
        if (fn.mobileAndTabletCheck()) {
            onFocusElement(`${_inputName}_modal`)
            if (vm.data.place_name && vm.data.place_name.length > 3) {
                setTimeout(() => {
                    const elem = document.getElementById(`${_inputName}_modal`)
                    if (elem) elem.setSelectionRange(0, elem.value.length);
                }, 200);
            }
        }

    }
   
    /***** Private *****/
    function ValidTotalPaxes(maxValue) {
        let paxesKeys = {};
        let adults = 0;
        let kids = 0;
        let rooms = vm.data.paxes.length;

        for (let i = 0; i < rooms; i++) {
            const room = vm.data.paxes[i];

            adults += room.adults;

            let childrens = room.children.length;
            let childreJoin = [];
            for (let c = 0; c < childrens; c++) {
                const childrenRoom = room.children[c];
                childreJoin.push(childrenRoom.year);
                kids += 1;
            }
        }
        paxesKeys[`adults`] = adults;
        paxesKeys[`kids`] = kids;
        const totalPaxes = paxesKeys[`adults`] + paxesKeys[`kids`];

        if (totalPaxes >= vm.settingPaxes.totalPaxes) {
            vm.error_paxes = true;
            return true;
        }
        else {
            vm.error_paxes = false;
            return false;
        }
    }

    function init() {
        initialDefaultDate();
        initSearchBox();
        initDatePicker();
        getInitialPlaces();
        updateInputPaxes();
        getSearchHistory();

        for (let index = vm.settingPaxes.minAge; index <= vm.settingPaxes.maxAge; index++) {
            vm.years.push({ year: index });
        }
    }

    function onSuccessSuggestion(response) {
        const data = response.data || [];
        vm.suggestion[_list]["results"] = data;
        vm.suggestion[_list]["show"] = true;
        vm.placeInputHasFocus[_list] = true;

        if (fn.mobileAndTabletCheck()) {
            onFocusElement(`${_inputName}_modal`)
        }
    }

    function onError(response) {
        console.log(response)
    }

    function initSearchBox() {
        let paramsData, storageData;

        if (setting.page != 'home') {
            paramsData = getUserSelectionParams();
        } else {
            storageData = SearchHistory.getFirstEntry("P");
        }

  
        if (storageData) {
            storageData.place_name = null;
            storageData.place_name_to = null;
            storageData.place_selected = {};
            storageData.place_selected_to = {};
        } 

        vm.data = paramsData || storageData || vm.data;
        if (paramsData || storageData) {
            vm.data.checkIn = fn.getDate(vm.data.checkIn);
            vm.data.checkOut = fn.getDate(vm.data.checkOut);
            if ((+vm.data.checkIn <= +defaultDate) || (+vm.data.checkOut <= +defaultDate)) {
                initialDefaultDate();
            }
        }
    }

    function AlgoliaSearch(element) {
        const params = {
            analyticsTags: getAnalyticsTags(),
            from: 0,
            language: config.language,
            placeTypes: 0,
            site: config.code,
            size: 5,
            usersearch: _userKey,
            recommendation: true,
            origin: !!origin && element === 'to' ? origin : null,
        }
        $http.get(config.endPoints.suggestionPackageUrl, { params: params }).then(onSuccessSuggestion, onError)
    }

    function initDatePicker() {
        let valid = isValidDate(vm.data.checkIn, vm.data.checkOut);
        if (!valid) {
            vm.data.checkOut = getInitialDate(vm.data.checkIn, config.bookerDefaultCheckOutDay);
        }

        onInitPicker(['calendar-checkIn-package', 'calendar-checkOut-package'], vm.data.checkIn, vm.data.checkOut, 'checkIn', 'checkOut')
    }


    function onInitPicker(element, startDate, endDate, checkIn, checkOut) {
        var css = !setting.rb ? [`${config.cloudCdn}/assets/css/dist/${config.siteName}/booker.css?id=${+(new Date())}`] : [];
        _datePicker = {
            element: document.getElementById(element[0]),
            css: css,
            zIndex: 10,
            grid: 2,
            calendars: 768 <= window.innerWidth ? 2 : 1,
            autoApply: true,
            readonly: true,
            lang: config.culture,
            date: startDate,
            format: localeDatePicker.format,
            plugins: [
                "RangePlugin",
                "LockPlugin"
            ],
            LockPlugin: {
                minDate: defaultDate,
                minDays: 2,
            },
            RangePlugin: {
                tooltip: true,
                startDate: startDate,
                endDate: endDate,
                tooltipNumber(num) {
                    return num - 1;
                },
                locale: {
                    one: lang.night,
                    other: lang.night + 's',
                }
            },
            setup(picker) {
                picker.on("render", (e) => {
                    const nextButtons = picker.ui.container.querySelectorAll(".calendars .next-button");
                    const prevButtons = picker.ui.container.querySelectorAll(".calendars .previous-button");
                    if (nextButtons) {
                        nextButtons.forEach((button) => {
                            button.setAttribute('aria-label', 'Siguiente mes');
                        });
                    }
                    if (prevButtons) {
                        prevButtons.forEach((button) => {
                            button.setAttribute('aria-label', 'Anterior mes');
                        });
                    }
                });
                picker.on('select', (e) => {
                    const { start, end } = e.detail;
                    vm.data[checkIn] = start.toJSDate();
                    vm.data[checkOut] = end.toJSDate();
                });
            },
        };


        _picker = new easepick.create(_datePicker);
    }

    function getUserSelectionParams() {
        let params = fn.search();
        let data = {}

        let placeOrigin = _placeOrigin;
        let placeDestination = _placeDestination;


        data.place_name = placeOrigin.placeDescription || "";
        data.place_name_to = placeDestination.placeDescription || "";

        data.place_selected = placeOrigin;
        data.place_selected_to = placeDestination;

        data.checkIn = params.startingFromDateTime || vm.data.checkIn;
        data.checkOut = params.returningFromDateTime || vm.data.checkOut;

        let rooms = +params.rooms;
        let paxes = [];

        for (let i = 0; i < rooms; i++) {
            let index = i + 1;
            let pax = {
                adults: +(params[`room${index}.adults`] || 2),
                children: []
            }
            let children = params[`room${index}.agekids`];
            if (children) {
                let childrenSplit = children.split(",");

                for (var c = 0; c < childrenSplit.length; c++) {
                    pax.children.push({
                        year: +(childrenSplit[c]) || 0
                    })
                }
            }
            paxes.push(pax);
        }

        if (paxes && !paxes.length) {
            paxes = vm.data.paxes;
        }

        data.paxes = paxes;

        return data;
    }

    function initialDefaultDate() {
        vm.data.checkIn = getInitialDate(defaultDate);
        vm.data.checkOut = getInitialDate(defaultDate, config.bookerDefaultCheckInDay + config.bookerDefaultCheckOutDay);
    }

    function getInitialDate(date = fn.getDate(), value = config.bookerDefaultCheckInDay) {
        let dateNew = fn.getDate(fn.formatDate(date, setting.formatDate));
        dateNew.setDate(dateNew.getDate() + value)
        return dateNew;
    }

    function getInitialPlaces() {
        let placesString = config.placesTypePackages;
        if (placesString) {
            placesString = placesString.split(",");
            for (let i = 0; i < placesString.length; i++) {
                _placesTypes[`placeTypes[${i}]`] = placesString[i];

            }
        }
    }


    function updateInputPaxes() {

        let adults = 0;
        let children = 0;
        let lengthPax = vm.data.paxes.length;

        for (let index = 0; index < lengthPax; index++) {
            const paxes = vm.data.paxes[index];
            adults += paxes.adults;
            children += paxes.children.length;
        }

        const roomTitle = lengthPax == 1 ? lang.room : lang.rooms;
        const adultsTitle = adults == 1 ? lang.adult : lang.adults;
        const childrenTitle = children == 1 ? lang.child : lang.children;
        let childrenText = "";
        let childrenTextRecent = "";
        if (children > 0) {
            childrenText = ` ${children} ${childrenTitle}, `;
            childrenTextRecent = ` ${children} ${childrenTitle}`;
        }
        vm.data.paxes_name = `${adults} ${adultsTitle},${childrenText} ${lengthPax} ${roomTitle}`;
        vm.data.paxes_name_recent = `${adults} ${adultsTitle},${childrenTextRecent}`;
        vm.data.paxes_people = adults + children;
        vm.data.capacityTotal = adults + children;
    }


    function isValidPax(pax, form) {
        let valid = true;
        let rooms = pax.length;

        for (let i = 0; i < rooms; i++) {
            const room = pax[i];

            let childrens = room.children.length;
            for (let c = 0; c < childrens; c++) {
                let inputKid = form[`children_${i}_${c}`];
                if (inputKid.$invalid) {
                    valid = false;
                    break;
                }
            }

            if (!valid) {
                break;
            }
        }

        return valid;
    }

    function isValidDate(dateFrom, dateTo) {
        let valid = true;

        dateFrom.setHours(0, 0, 0, 0);

        if (+dateFrom > +dateTo) {
            valid = false;
        }
        return valid;
    }

    function onFocusElement(nameDiv) {
        setTimeout(() => {
            let element = nameDiv && document.getElementById(nameDiv);
            if (element) {
                element.focus();
            }
        }, 200)

    }

    function setValidation(prop) {
        if (prop == 'paxes') {
            vm.validation.paxes = isValidPax(vm.data.paxes, vm.form);
        }
    }

    function somePaxHasError() {
        if (vm.data && vm.data.paxes && vm.data.paxes.length) {
            for (let a = 0; a < vm.data.paxes.length; a++) {
                let pax = vm.data.paxes[a];
                if (pax && pax.children) {
                    if (pax.children.some(child => child.year === null || child.year === undefined)) {
                        return true;
                    }
                }
            }
        }
        return false;
    }


    function getSearchHistory() {
        vm.history = SearchHistory.getPackage("P");
        ['from', 'to'].forEach(key => {
            vm.history[key]?.forEach(item => {
                item.placeName = stripHtml(item.placeName);
            });
        });
    }

    function getAnalyticsTags() {
        var arrTags = [];
        if (fn.mobileAndTabletCheck()) {
            arrTags.push("web_mobile");
        } else {
            arrTags.push("web_desktop");
        }
        var pathName = _globalUtil.getFirstPathSegment();
        if (pathName == "hotel") {
            arrTags.push("detail");
        } else if (pathName == "hoteles" || pathName == "hotels") {
            arrTags.push("list");
        } else if (setting.page == 'landings') {
            arrTags.push("landings");
        } else {
            arrTags.push("home");
        }
        return arrTags.join(',');
    }

    vm.handleCloseSuggestions = function(suffix) {
        if (suffix != undefined) {
            var item = vm.data[`place_selected${suffix}`];
            var place_name = item ? (item.version == "v2" ? textOrigen(item) : textValidation(item)) : ""
            if (vm.data[`place_name${suffix}`] != place_name) {
                vm.data[`place_name${suffix}`] = null
                vm.data[`place_selected${suffix}`] = {};
            }
        }
    };

    function textOrigen(suggestion) {
        const text = `${suggestion.placeDescription}, ${stripHtml(suggestion.placeName)} (${suggestion.placeCode})`;
        return text;
    }

    function textValidation(suggestion) {
        const placeName = stripHtml(suggestion.placeName);
        const placeDescription = stripHtml(suggestion.placeDescription);
        const text = placeName == placeDescription ? placeName : `${placeDescription}, ${placeName}`;
        return text;
    }

    function stripHtml(html) {
        const tmp = document.createElement("div");
        tmp.innerHTML = html;
        return tmp.textContent || tmp.innerText || "";
    }

    vm.codeValidation = function(suggestion, type) {
        const validation = type == "from" ? suggestion.placeType != 1 : suggestion.placeTypeIcon != 18;
        return validation;
    }

    init();
}
